<template>
    <div class="update-log">
        <a-card :bordered="false">
            <template slot="title">
                <a-icon type="profile" />
                {{ l('updatelog') }}
            </template>
            <template slot="extra">
                <a-checkbox
                    class="update-log__major-check"
                    :checked="onlyMajor"
                    @change="onOnlyMajorChange"
                >
                    只看重大更新
                </a-checkbox>
                <a-button
                    v-for="year in years"
                    :key="year"
                    size="small"
                    class="update-log__year-btn"
                    @click="scrollToYear(year)"
                >
                    {{ year }}
                </a-button>
            </template>
            <a-collapse v-model="activeYears" :bordered="false" class="update-log__collapse">
                <a-collapse-panel v-for="year in years" :key="year">
                    <template slot="header">
                        <span :id="`update-log-year-${year}`" class="update-log__year-header">{{ year }} 年</span>
                    </template>
                    <a-timeline>
                        <a-timeline-item v-for="log in displayLogsByYear[year]" :key="log.version">
                            <p class="update-log__version">
                                <b>{{ log.version }}</b>
                                <span class="update-log__date">{{ log.date }}</span>
                            </p>
                            <ul class="update-log__items">
                                <li v-for="(item, index) in log.items" :key="index" :class="{ 'update-log__item-major': isMajor(item) }">
                                    <a-tag v-if="isMajor(item)" color="red" class="update-log__major-tag">重大更新</a-tag>
                                    {{ isMajor(item) ? item.replace(/^【重大】/, '') : item }}
                                </li>
                            </ul>
                        </a-timeline-item>
                    </a-timeline>
                </a-collapse-panel>
            </a-collapse>
        </a-card>
        <a-back-top :visibility-height="300" :target="getScrollContainer" />
    </div>
</template>

<script>
    import { AppComponentBase } from '@/shared/component-base';
    import { updateLogs } from './update-log-data';

    export default {
        name: 'update-log',
        mixins: [AppComponentBase],
        data() {
            const logsByYear = {};
            // 年份倒序
            for (const log of updateLogs) {
                const year = log.date.slice(0, 4);
                (logsByYear[year] = logsByYear[year] || []).push(log);
            }
            const years = Object.keys(logsByYear).sort().reverse();
            return {
                logsByYear,
                years,
                // 默认只展开最近一个年度
                activeYears: years.length ? [years[0]] : [],
                onlyMajor: false,
            };
        },
        computed: {
            // 勾选“只看重大更新”后，仅保留包含重大更新的版本，且每个版本内只显示重大条目
            displayLogsByYear() {
                if (!this.onlyMajor) {
                    return this.logsByYear;
                }
                const result = {};
                for (const year of this.years) {
                    const logs = this.logsByYear[year]
                        .map(log => ({ ...log, items: log.items.filter(i => this.isMajor(i)) }))
                        .filter(log => log.items.length > 0);
                    if (logs.length > 0) {
                        result[year] = logs;
                    }
                }
                return result;
            },
        },
        methods: {
            // 布局的滚动发生在 .layout-content 容器上，而非 window
            getScrollContainer() {
                return document.querySelector('.layout-content');
            },
            // 以【重大】开头的条目为重大功能更新
            isMajor(item) {
                return item.startsWith('【重大】');
            },
            onOnlyMajorChange(e) {
                this.onlyMajor = e.target.checked;
            },
            scrollToYear(year) {
                // 跳转的同时展开对应年度
                if (!this.activeYears.includes(year)) {
                    this.activeYears.push(year);
                }
                this.$nextTick(() => {
                    const el = document.getElementById(`update-log-year-${year}`);
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    .update-log {
        padding: 16px;

        &__major-check {
            margin-right: 12px;
        }

        &__year-btn {
            margin-left: 4px;
        }

        &__year-header {
            font-size: 16px;
            font-weight: bold;
        }

        &__collapse {
            background: transparent;

            /deep/ .ant-collapse-item {
                border-bottom: none;
            }

            /deep/ .ant-collapse-header {
                font-size: 16px;
                font-weight: bold;
            }

            /deep/ .ant-collapse-content-box {
                padding: 8px 0 8px 8px;
            }
        }

        &__version {
            margin-bottom: 4px;

            b {
                font-size: 15px;
            }
        }

        &__date {
            margin-left: 12px;
            color: rgba(0, 0, 0, 0.45);
        }

        &__items {
            margin: 0;
            padding-left: 20px;

            li {
                margin-bottom: 4px;
            }
        }

        &__item-major {
            font-weight: bold;
        }

        &__major-tag {
            margin-right: 4px;
        }
    }
</style>
